<template>
  <div class="newsroom">
    <a-row>
      <h3 class="nrTitle">Get to know the latest news about Sian</h3>
    </a-row>

    <a-row>
      <a-col :md="{ span: 24 }" :xs="{ span: 24 }" v-for="post in posts.dataSet">
        <a-row class="post">
          <article>
            <a-col :sm="{ span: 6 }">
              <img :src="thumbUrl(post.text)" alt class="postThumb" />
            </a-col>
            <a-col :sm="{ span: 17, offset: 1 }">
              <a-row>
                <a-col>
                  <router-link :to="'/newsroom/' + post.slug">
                    <h3>{{ post.title }}</h3>
                  </router-link>
                </a-col>
                <a-col>
                  <span>
                    Date: &nbsp; {{ post.month }}-{{ post.day }}-{{
                    post.year
                    }}
                    {{ convertUnixTimeStamp(post.created) }}
                  </span>
                </a-col>
                <a-col>
                  <p>
                    {{ post.digest
                    }}
                    <router-link :to="'/newsroom/' + post.slug" class="blueReminder">Learn More</router-link>
                  </p>
                </a-col>
              </a-row>
            </a-col>
          </article>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="end">
      <a-col>
        <a-pagination @change="onChange" v-model="currentPage" :total="posts.pages * 10" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  name: "Newsroom",
  metaInfo: {
    title: "Newsroom"
  },
  data() {
    return {
      posts: "postsContent",
      currentPage: 1
    };
  },
  methods: {
    convertUnixTimeStamp(unixtimestamp) {
      let createdTime = new Date(unixtimestamp * 1000);
      let months_arr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      let year = createdTime.getFullYear();
      let month = months_arr[createdTime.getMonth()];
      let day = createdTime.getDay();
      let hours = createdTime.getHours();
      let minutes = "0" + createdTime.getMinutes();

      let formatedCreatedTime = hours + ":" + minutes.substr(-2);
      return formatedCreatedTime;
    },
    getPosts() {
      fetch(
        "https://rest.cnsian.com/api/posts?filterType=category&filterSlug=newsroom&showDigest=excerpt&showContent=true"
      )
        .then(response => response.json())
        .then(data => {
          this.posts = data.data;
          this.currentPage = this.posts.page;
        });
      // axios
      //   .get(
      //     "https://rest.cnsian.com/api/posts?filterType=category&filterSlug=newsroom&showDigest=excerpt&showContent=true"
      //   )
      //   .then(response => {
      //     this.posts = response.data.data;
      //     this.currentPage = this.posts.page;
      //   });
    },
    thumbUrl(str) {
      let url;
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function(match, capture) {
        url = capture;
      });
      if (!url) {
        return "https://img.cnsian.com/images/f6dec6869496ca0deb58535c7c7a0997.jpg";
      } else {
        return url;
      }
    },
    onChange(currentPage) {
      // console.log(currentPage);
      fetch(
        "https://rest.cnsian.com/api/posts?filterType=category&filterSlug=newsroom&showDigest=excerpt&showContent=true&page=" +
          currentPage
      )
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.posts = data.data;
          this.currentPage = this.posts.page;
        });
      // axios
      //   .get("https://rest.cnsian.com/api/posts?filterType=category&filterSlug=newsroom&showDigest=excerpt&showContent=true&page=" + currentPage)
      //   .then(response => {
      //     this.posts = response.data.data;
      //     this.currentPage = this.posts.page;
      //   });
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.getPosts();
      }
    }
  }
};
</script>

<style lang="scss">
.newsroom {
  padding: 0 12.5%;
  margin: 3em 0 6em 0;
  .nrTitle {
    color: rgba(0, 0, 0, 0.5);
  }
  .post {
    padding: 3em 0;
    span {
      color: rgba(0, 0, 0, 0.5);
      font-size: 17px;
    }
    .postThumb {
      width: 100%;
      height: 100%;
    }
    .blueReminder {
      color: #1890ff;
    }
  }
}
</style>
